import React, { useCallback } from 'react';
import { View } from 'react-native';
import { compose } from 'redux';

import { DetailContainer } from '../../containers';

import { Text, TextInput } from '../../components';
import { PrimaryButton } from '../../design/components';
import { useDialogContext, useUserContext } from '../../../common/utils/context';
import SwitchWithLabel from '../../components/switch/SwitchWithLabel';
import { useForm } from '../../../common/utils/hooks';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createNoteFormStyles } from './noteFormStyles';

const NoteDetail = ({
	data: note,
	modifyItem: modifyNote,
	showImportant,
}) => {
	const { values, changeFormValue } = useForm(note);
	const { user } = useUserContext();
	const { closeDialog } = useDialogContext();
	const styles = useThemedStyles(createNoteFormStyles);

	const handleOnChange = useCallback(field => value => {
		changeFormValue({ [field]: value });
	}, [changeFormValue]);

	const handleOnSubmit = useCallback(async () => {
		const { description, isAdminNote, isImportant } = values;
		await modifyNote({ description, isAdminNote, isImportant });
		closeDialog();
	}, [modifyNote, values, closeDialog]);

	return (
		<View style={styles.form}>
			<View style={styles.field}>
				<Text style={styles.label}>Description</Text>
				<TextInput
					multiline={true}
					numberOfLines={4}
					style={styles.multilineInput}
					value={values.description}
					onChange={handleOnChange('description')}
				/>
			</View>
			{
				user.role?.canSeeAdminNotes && (
					<SwitchWithLabel
						value={values.isAdminNote}
						label="Admin note"
						onValueChange={handleOnChange('isAdminNote')}
					/>
				)
			}
			{
				Boolean(showImportant) && (
					<SwitchWithLabel
						value={values.isImportant}
						label="Important"
						onValueChange={handleOnChange('isImportant')}
					/>
				)
			}
			<PrimaryButton
				label="Save note"
				disabled={!values.description}
				onPress={handleOnSubmit}
			/>
		</View>
	);
};

export default compose(DetailContainer)(NoteDetail);
